import { useEffect, useState } from 'react';

import { DataState } from '../context/DataProvider';
import { getSharePointConnection } from '../services/api';

// place_id -> name for the member's SharePoint places, so approval cards say
// "SuperManager AGi" instead of "contoso.sharepoint.com,83d2…". Names come
// from the member's own connection (the sites they turned on), never from the
// model. One request per page load, shared by every card.

let cache = null; // Promise<Record<string, string>>

const ONEDRIVE = { onedrive: 'My OneDrive' };

const load = (userGoogleId) => {
  if (!cache) {
    cache = getSharePointConnection(userGoogleId)
      .then((connection) => {
        const names = { ...ONEDRIVE };
        (connection?.sites || []).forEach((site) => {
          if (site?.id)
            names[site.id] = site.name || site.web_url || 'SharePoint site';
        });
        return names;
      })
      .catch(() => {
        cache = null; // retry on the next card
        return { ...ONEDRIVE };
      });
  }
  return cache;
};

// Sites turned on or off later change the answer; the panel calls this.
export const forgetSharePointPlaceNames = () => {
  cache = null;
};

const useSharePointPlaceNames = (enabled) => {
  const { userGoogleId } = DataState();
  const [names, setNames] = useState(ONEDRIVE);

  useEffect(() => {
    if (!enabled || !userGoogleId) return undefined;
    let alive = true;
    load(userGoogleId).then((loaded) => {
      if (alive) setNames(loaded);
    });
    return () => {
      alive = false;
    };
  }, [enabled, userGoogleId]);

  return names;
};

export default useSharePointPlaceNames;
